import React, { useRef } from "react";
import { IUserApiClient, UserAdressDto, UserDto } from "../clients/userApiClient";
import { useInjection } from "../di/ioc-provider"
import { TYPES } from "../di/types"
import { AuthStore } from "../stores/AuthStore";
import { SortOrder } from "../clients/dossierApiClient";
import { Alert, FormControl, Grid, InputLabel, Select } from "@mui/material";
import { useTranslation } from "react-i18next";
import { List } from "linqts";
import { LoadButton } from "./loadButton";
import GeneralDialog from "./generalDialog";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { useImmer } from "use-immer";

export interface UserPickerProps {
    onUserAddressSelected: (user: number) => void;
}
export interface CreateAddressForm {
    companyName: string;
    address: string;
    postalCode: string;
    city: string;
    houseNr: string;
    vatCode: string;
}
export const UserAddressPicker = (props: UserPickerProps) => {


    const _userService = useInjection<IUserApiClient>(TYPES.IUserClient);
    const authObj = AuthStore.useState(w => w.authSettings);
    const [t] = useTranslation("common");
    const [address, setUserAddresses] = React.useState<UserAdressDto[]>([]);
    const formRef = useRef(null);
    const [saving, setLoading] = React.useState(false);
    const [success, setSuccess] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [userAddressDialog, setUserAddressDialog] = React.useState<boolean>(false);
    const [formModel, setFormModel] = useImmer<CreateAddressForm>({ companyName: "", vatCode: "", address: "", houseNr: "", city: "", postalCode: "" });

    React.useEffect(() => {
        fetchAddresses();
    }, [])

    const fetchAddresses = () => {
        _userService.fetchAddresses()
            .then((res) => {
                setUserAddresses(new List(res.data).OrderBy(w => w.companyName).ToArray());
            })
    }
    const handleSelect = (e: any) => {
        props.onUserAddressSelected(e.target.value);
    }
    const createUserAddress = () => {
        setLoading(true);
        _userService.createUserAddress(formModel).takeAtLeast(1000).then((res) => {
            setSuccess(true);
            setTimeout(() => {
                setUserAddressDialog(false);
                fetchAddresses();
            }, 1500)
        }).catch((err) => {
            setError(true);
        }).finally(() => {
            setLoading(false);
        })
    }
    const saveValidate = () => {
        if (formRef != null && formRef.current != null) {
            var testForm = formRef.current as any;
            testForm
                .isFormValid()
                .then((result: boolean) => {
                    if (result) {
                        createUserAddress();
                    }
                })
                .catch((err: any) => { });
        }
    };

    return <>
        <GeneralDialog title={t("general.userAddressPickerDialog")} open={userAddressDialog} onClose={() => setUserAddressDialog(false)}>
            <ValidatorForm style={{ width: "100%" }} ref={formRef} onSubmit={() => { }}>
                {error ? <Alert sx={{ mt: "4px", mb: "4px" }} severity="error">{t("login.createUserAddressError")}</Alert> : null}
                {success ? <>
                    <Alert sx={{ mt: "4px", mb: "4px" }} severity="success" >{t("login.createUserAddressSuccess")}</Alert>
                </> : <></>}
                <TextValidator
                    disabled={saving}
                    margin="normal"
                    fullWidth
                    label={t("general.companyName")}
                    name="companyName"
                    value={formModel.companyName}
                    autoFocus
                    validators={["required"]}
                    errorMessages={[t("validation.required")]}
                    onChange={(ev) => {
                        setFormModel((draft) => { draft.companyName = ev.target.value })
                    }}
                />
                <TextValidator

                    disabled={saving}
                    margin="normal"

                    fullWidth
                    label={t("general.custVat")}
                    name="vat"
                    value={formModel.vatCode}
                    autoFocus
                    validators={["required"]}
                    errorMessages={[t("validation.required")]}
                    onChange={(ev) => {
                        setFormModel((draft) => { draft.vatCode = ev.target.value })
                    }}
                />
                <Grid container spacing={1}>
                    <Grid item xs={12} md={10}>
                        <TextValidator

                            disabled={saving}
                            margin="normal"

                            fullWidth
                            label={t("general.custStreet")}
                            name="email"
                            value={formModel.address}
                            validators={["required"]}
                            errorMessages={[t("validation.required")]}
                            onChange={(ev) => {
                                setFormModel((draft) => {
                                    draft.address = ev.target.value;
                                })
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <TextValidator

                            disabled={saving}
                            margin="normal"

                            fullWidth
                            label={t("general.custHouseNr")}
                            name="email"
                            value={formModel.houseNr}
                            validators={["required"]}
                            errorMessages={[t("validation.required")]}
                            onChange={(ev) => {
                                setFormModel((draft) => {
                                    draft.houseNr = ev.target.value;
                                })
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextValidator

                            disabled={saving}
                            margin="normal"

                            fullWidth
                            label={t("general.custPostal")}
                            name="email"
                            value={formModel.postalCode}
                            validators={["required"]}
                            errorMessages={[t("validation.required")]}
                            onChange={(ev) => {
                                setFormModel((draft) => {
                                    draft.postalCode = ev.target.value;
                                })
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextValidator

                            disabled={saving}
                            margin="normal"

                            fullWidth
                            label={t("general.custCity")}
                            name="email"
                            value={formModel.city}
                            validators={["required"]}
                            errorMessages={[t("validation.required")]}
                            onChange={(ev) => {
                                setFormModel((draft) => {
                                    draft.city = ev.target.value;
                                })
                            }}
                        />
                    </Grid>
                </Grid>

                <LoadButton
                    style={{ width: "100%", marginTop: "14px" }}
                    isLoading={saving}
                    type="submit"
                    variant="contained"
                    buttonText={t("general.create")}
                    onClick={saveValidate}>

                </LoadButton>

            </ValidatorForm>
        </GeneralDialog>
        <Grid container>
            <Grid item xs={12}>
                <FormControl variant="outlined" style={{ width: "100%" }}>
                    <InputLabel htmlFor="userPicker">{t("general.userAddressPickerLabel")}</InputLabel>

                    <Select
                        style={{ marginTop: "16px" }}
                        native
                        label={t("general.userAddressPickerLabel")}
                        onChange={handleSelect}
                        id="userAddressPicker"
                    >
                        <option value={null}>Hoofdadres</option>
                        {address.map((el) => {
                            return <option value={el.id}>{el.companyName} {el.vatCode}</option >
                        })}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <LoadButton
                    style={{ marginTop: "10px" }}
                    isLoading={false}
                    variant="contained"
                    buttonText={t("general.createUserAddress")}
                    onClick={() => { setUserAddressDialog(true) }}>
                </LoadButton>
            </Grid>
        </Grid>
    </>
}